import { render, staticRenderFns } from "./CustomersInvoiceColumn.vue?vue&type=template&id=505a9610&"
import script from "./CustomersInvoiceColumn.vue?vue&type=script&lang=js&"
export * from "./CustomersInvoiceColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports